import React, { useRef } from 'react';
import classnames from 'classnames';
import { Bubble } from '@home/components/TeaComponents';
import useIsTextOverflow from './_hooks/useIsTextOverflow';

import type { BubbleProps } from 'tea-component';

import './index.scss';

interface IEllipsisHoverProps extends IBaseProps, Omit<BubbleProps, 'children'> {
  text: string;
  bubbleText?: string;
}

const EllipsisHover: React.FC<IEllipsisHoverProps> = (props) => {
  const { style, className, placement = 'top', text, bubbleText } = props;

  const wrapper = useRef<HTMLDivElement | null>(null);

  const isOverflow = useIsTextOverflow(wrapper, { text });

  return (
    <div style={style} className={classnames('dbg-ellipsis-hover', className)}>
      <Bubble
        dark
        arrowPointAtCenter
        overlayClassName="dbg-bubble-max-width dbg-ellipsis-hover__text-bubble"
        placement={placement}
        content={!isOverflow ? undefined : bubbleText ?? text}
      >
        <div ref={wrapper} className="dbg-ellipsis-hover__text-wrapper">
          <span className="dbg-ellipsis-hover__text-content">{text}</span>
        </div>
      </Bubble>
    </div>
  );
};

export default EllipsisHover;
